module.exports = __webpack_public_path__ + "static/media/Home_Background_Bookmakers_Mobile.dbdcc3fc.png";